import React from 'react';

const MagnifierIcon = ({ fill = '#ffffff', className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M11.4444 6.22222C11.4444 9.10638 9.10637 11.4444 6.22222 11.4444C3.33807 11.4444 1 9.10638 1 6.22222C1 3.33807 3.33807 1 6.22222 1C9.10637 1 11.4444 3.33807 11.4444 6.22222Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M4.11133 7.2222C4.11133 5.50398 5.50422 4.11108 7.22244 4.11108"
        stroke={fill}
        strokeWidth="2"
      />
      <line
        x1="10.0401"
        y1="10.1818"
        x2="14.7068"
        y2="14.8485"
        stroke={fill}
        strokeWidth="2"
      />
    </svg>
  );
};

export default MagnifierIcon;
